module.exports = __webpack_public_path__ + "static/media/logo.a50e8ec6.png";